export const isAlignedWithGlobalKpiFeatureFlag = (
  isGlobalKpisEnabled: boolean | undefined,
  categoryId: string
) => {
  if (
    isGlobalKpisEnabled &&
    (categoryId === 'db115e21-cd08-4bd1-aeda-ebdc892505a6' || // BUSINESS_CONDUCT
      categoryId === 'e3fdcd80-800e-4ca9-abab-e4495fb5fb6f' || // SUPPLY_CHAIN
      categoryId === '0c1ab3dd-8c6a-4b5a-b1ab-d97d50b1283c') // GOVERNANCE_BODIES
  ) {
    return false;
  }

  return true;
};
